import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditTilvalgDialogData } from '../../aftale/models';
import moment from 'moment';
import { EftersynStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/eftersyn-state-enum';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';

@Component({
    selector: 'app-edit-serviceabonnement-tilvalg-dialog',
    templateUrl: './edit-serviceabonnement-tilvalg-dialog.component.html',
    styleUrls: ['./edit-serviceabonnement-tilvalg-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditServiceabonnementTilvalgDialogComponent implements OnInit {
  eftersynStateEnum = EftersynStateEnum;
  serviceaftale: ServiceaftaleDto;
  validFrom: Date;
  nextServiceintervalStartDate: Date;
  today: Date;
  overskrift: string;
  buttonTekst: string;
  allowInstantChange: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<EditServiceabonnementTilvalgDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditTilvalgDialogData
  ) {
    this.serviceaftale = data.serviceaftale;
    this.overskrift = data.overskrift;
    this.buttonTekst = data.buttonTekst;
    this.allowInstantChange = data.allowInstantChange;
  }

  ngOnInit(): void {
    this.today = moment().toDate();
    this.nextServiceintervalStartDate = this.data.serviceaftale.currentServiceinterval?.endDate
      ? moment(this.data.serviceaftale.currentServiceinterval.endDate).add(1, 'day').toDate()
      : null;
    this.validFrom = this.nextServiceintervalStartDate ? this.nextServiceintervalStartDate : this.today;
  }

  submit() {
    this.dialogRef.close(moment(this.validFrom).toDate().toOkDateString());
  }
}
